import { createFileRoute } from "@tanstack/react-router";
import SupportCenter from "@/components/support/SupportCenter";

export const Route = createFileRoute("/student/support/")({
  component: () => <SupportCenter dashboardPath="/student/dashboard" />,
});
